export default "__VITE_ASSET__E_GSjKzP__"